module.exports = __webpack_public_path__ + "img/ride-credit-program.5c948c7a.png";